import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-image-sub-engagement',
  templateUrl: './image-sub-engagement.component.html',
  styleUrls: ['./image-sub-engagement.component.scss']
})
export class ImageSubEngagementComponent implements OnInit {

  @Output() whiteListed: EventEmitter<boolean> = new EventEmitter;
  

  whitelistUser : any = [];
  getPaginationCount;
  page = 1;

  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  commonSearch : any = "";
  subTaskId : any = "";
  localData: any;
  constructor(
    private router: Router,
    private exportExcelService: ExportExcelService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private activatedRoute : ActivatedRoute
  ) { 
    this.localData = JSON.parse(localStorage.getItem("engagementDetail"))
  }

  ngOnInit() {
    this.getWhitelistUser();
  }
  uploadExcel(){
    this.router.navigate(["/hubAdmin/image-task-setup-excel-upload/"+this.localData.task_id + "/" + this.localData.engagement_type_id])
  }

  filter(){
    this.getWhitelistUser();
  }

  getWhitelistUser(){
    this.excelArray = [];
    this.excelData = [];

    this.apiService.getHeaders(this.apiConfig.engagemetnWhitelistUser + `?engagement_page=${this.page}&engagement_type=${this.localData.engagement_type_id}&task_id=${this.localData.task_id}&search=${this.commonSearch}&has_subtask=${this.localData.has_subtask}&sub_task_id=${this.localData.sub_tasks_id}`).subscribe((res : any)=>{
      console.log(res)
      this.whitelistUser = res.body.data.data;
      //2) for excelData
      // this.excelData = res.body.data.full_data;
      // for (var k in this.excelData[0]) {
      //   if (typeof this.excelData[k] !== 'function') {
      //     console.log("Key is " + k.replace(/_/g, ' '));
      //     this.excelFormat.header = k.replace(/_/g, ' ');
      //     this.excelFormat.key = k
      //     this.excelArray.push(JSON.parse(JSON.stringify(this.excelFormat)));
      //     console.log(this.excelArray)
      //   }
      // }
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
     
    })
  }

  DownloadReportExcel() {
    this.exportExcelService.DownloadReportExcel('Point_configuration', this.excelData, this.excelArray);
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getWhitelistUser();

  }

  submit(){
   this.whiteListed.emit(true)

  }

  toggleStatus(user){
  this.apiService.get(this.apiConfig.deactiveEnagegementUser + `?engagement_page=1&engagement_type=${this.localData.engagement_type_id}&task_id=${user.task_id}&search=${this.commonSearch}`).subscribe((res : any)=>{
    console.log(res)
    this.getWhitelistUser();
    return user.status = 0;
  })
    console.log("toggle")

  }

  viewSubTask(){
    this.router.navigate(["/hubAdmin/image-sub-engagement"])
  }
}
